module.exports = __webpack_public_path__ + "components/flag/static/square/tk-bf0657d4f8911ccd8d73a0bc9efec475.svg";